import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { ModuleManager } from "src/shared/models/module-manager";
import { IModuleManagerToolbarComponent } from "src/shared/models/module-manager/module-manager-toolbar-component.model";
import { RankingRow } from "../leaderboard.model";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { Subject } from "rxjs";

@Component({
    selector: "cv-leaderboard-my-metric",
    templateUrl: "./leaderboard-my-metric.component.html",
    styleUrls: ["./leaderboard-my-metric.component.scss"]
})
export class LeaderboardMyMetricComponent
    implements IModuleManagerToolbarComponent, OnInit, OnDestroy
{
    @Input() moduleManager: ModuleManager;
    @Input() context?: Subject<{
        rowData: RankingRow[];
        noRankings: boolean;
        hasCurrentMetrics: boolean;
    }>;
    currentUserRanking: string = null;
    hasCurrentMetrics = false;

    @ViewChild('rankElement') rankElement: ElementRef;
    @HostBinding('class.full-width') get isFullWidth() { return this.hasCurrentMetrics || this.moduleManager.moduleSettings.hideDatePicker; }
    @HostBinding('class.partial-width') get isPartialWidth() { return !this.hasCurrentMetrics && !this.moduleManager.moduleSettings.hideDatePicker; }

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private cd: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.context?.subscribe(({rowData, noRankings, hasCurrentMetrics}) => {
            this.loadCurrentUserRanking(rowData, noRankings, hasCurrentMetrics);
        });
    }

    ngOnDestroy(): void {
        this.context?.unsubscribe();
    }

    loadCurrentUserRanking(rowData: RankingRow[], noRanking: boolean, hasCurrentMetrics: boolean): void {
        if (this.context) {
            const currentRankUser = rowData.find(row => row.IsCurrentUser);
            if (currentRankUser) {
                this.getRank(currentRankUser, noRanking);
            } else {
                this.currentUserRanking = null;
            }
            this.hasCurrentMetrics = hasCurrentMetrics;
            this.cd.detectChanges();
        }
    }

    getRank(rank: RankingRow, noRanking: boolean) {
        if (rank.MetricData.MetricDisplayValue !== null && rank.MetricData.MetricDisplayValue !== 'N/A' && !noRanking) {
            this.currentUserRanking = rank.Place
        }
        else {
            this.currentUserRanking = this.cvLocalizationService.getCachedText('Leaderboard_Module', 'Rank_NA');
        }
    }

    getLocalizedText(section: string, key: string, defaultValue: string): string {
        return this.cvLocalizationService.getCachedText(section, key, defaultValue);
    }

    isTextTruncated(): boolean {
        if (!this.rankElement || !this.rankElement.nativeElement) {
            return false;
        }
        const element = this.rankElement.nativeElement;
        return element.scrollWidth > element.clientWidth;
    }
}

